import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components/macro';
import { desktopStyles, mobileStyles } from '../../styles';

// TO ADJUST AFTER WIDGET REFACTOR
// max-width: ${({ $isTip }) => ($isTip ? '32.6rem' : 'unset')};
export const WorflowWrapper = styled(FlexContainer)<{ $isTip?: boolean }>`
  ${mobileStyles} {
    max-width: ${({ $isTip }) => ($isTip ? '36rem' : 'unset')};
    margin-top: 0.4rem;
  }

  & .sc-facephi-selphid-widget.sc-tip-widget-h {
    ${mobileStyles} {
      justify-content: flex-start;
    }
  }

  & .tip-content.sc-facephi-workflow-widget {
    ${mobileStyles} {
      margin: 0;
    }
  }

  .sc-facephi-selphi-widget.sc-tip-widget-h {
    ${mobileStyles} {
      justify-content: center;
    }
  }

  .sc-facephi-workflow-widget-h {
  @media (max-height: 676px) {
    height: 100%;
    flex: 1;
  }
    height: unset;
    flex: none;
  }
  section.sc-facephi-selphid-widget {
    ${mobileStyles} {
      padding: unset;
    }
  }

  p.sc-tip-widget {
    margin-top: unset;
  }

  & button {
    text-transform: uppercase;
  }

  ${desktopStyles} {
    justify-content: center;

    facephi-workflow-widget {
      overflow: hidden;
      border-radius: 1.5rem;
      background: white;
      max-width: 80rem;s
      max-height: 80rem;
      box-shadow: 0px 2px 14px 0px rgba(234, 238, 246, 1);
    }
  }
`;
